import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import {
    Alert,
    Avatar,
    Box,
    Breadcrumbs,
    Button,
    Card,
    CardActionArea,
    Chip,
    Container,
    Dialog,
    Divider,
    IconButton,
    LinearProgress,
    Paper,
    Skeleton,
    Snackbar,
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Email, MarkEmailRead } from "@mui/icons-material";
import { getsessionuser } from "../Utils/sessions";
import { isMobile, isDesktop } from "react-device-detect";
import {
    Fetchindividualblogsurl,
    Fetchsingleblogurl,
    Followblogurl,
    Subscribeblogurl,
    Updateblogclicksurl,
} from "../Utils/urls";
import SignIn from "../Common/login";
import Universalheader from "../Headers/universalheader";
import Sharepopup from "../Components/sharepopup";
import { blogminutes, createMarkup, setFavicon } from "../Utils/functions";
import { convertToHTML } from "draft-convert";
import { convertFromRaw } from "draft-js";
import { imageplaceholder } from "../Utils/defaults";

// ---------- Design tokens ----------
const brand = {
    indigo: "#900f20",
    indigoDark: "#900f20",
    blueAccent: "#900f20",
    bg: "#F7F8FA",
    ink: "#111827",
    slate: "#6B7280",
};

const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.55, delay: i * 0.08, ease: "easeOut" },
    }),
};

const Viewsingleblog = ({ onrefresh }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const id = location.pathname.split("/")[3];
    const tempuser = getsessionuser();
    const [user, setuser] = useState(tempuser);
    const [refresh, setrefresh] = useState(false);

    const [blog, setblog] = useState("");
    const [blogs, setblogs] = useState([]);
    const [progress, setprogress] = useState(true);
    const [error, seterror] = useState("");
    const [showloginpopup, setshowloginpopup] = useState(false);
    const [showloginpopup2, setshowloginpopup2] = useState(false);
    const [sharepopup, setsharepopup] = useState(false);

    const url = "https://eazistey.co.ke/nav/viewsingleblog/" + id;
    const [popupdiv, setpopupdiv] = useState(false);
    const [defaulturl, setdefaulturl] = useState("");

    const [followingstatus, setfollowingstatus] = useState(false);
    const [subscribingstatus, setsubscribingstatus] = useState(false);

    // ---------- UI-only additions (no backend calls) ----------
    const [bookmarked, setbookmarked] = useState(false);
    const [linkcopied, setlinkcopied] = useState(false);
    const [scrollprogress, setscrollprogress] = useState(0);

    useEffect(() => {
        const userobject = sessionStorage?.getItem("user");
        if (userobject) {
            const object = JSON.parse(userobject);
            setuser(object);
            getblog(object);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refresh]);

    useEffect(() => {
        getblog();
        Updateclicks();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // reading progress bar (UI-only, does not affect any business logic)
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            setscrollprogress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const Updateclicks = () => {
        axios.post(Updateblogclicksurl, {
            id: id,
        });
    };

    const getblog = (e) => {
        setprogress(true);
        seterror(null);
        axios
            .post(Fetchsingleblogurl, {
                id: id,
            })
            .then((response) => {
                setprogress(false);
                if (!response.data.message) {
                    response.data.content = convertToHTML(convertFromRaw(JSON.parse(response.data?.content)));
                    setblog(response.data);
                    fetchallblogs(response.data.userid);
                    setdefaulturl(response.data.blogurl);

                    setFavicon(response.data.blogurl);
                    document.title = response.data.title;
                    document.querySelector('meta[name="description"]').setAttribute("content", response.data.title);

                    //check followstatus
                    if (response.data.blogfollowers.length > 0) {
                        const formattedfollowers = JSON.parse(response.data.blogfollowers);
                        const index = formattedfollowers.indexOf(user ? user.id : e ? e.id : 0);
                        if (index > -1) {
                            //if user is already following
                            setfollowingstatus(true);
                        } else {
                            setfollowingstatus(false);
                        }
                    }

                    //check  subscribe status
                    if (response.data.blogsubscribers.length > 0) {
                        const formattedfollowers = JSON.parse(response.data.blogsubscribers);
                        const index = formattedfollowers.indexOf(user ? user.id : e ? e.id : 0);
                        if (index > -1) {
                            //if user has already subscribed
                            setsubscribingstatus(true);
                        } else {
                            setsubscribingstatus(false);
                        }
                    }
                } else {
                    seterror(response.data.message);
                }
                //
            })
            .catch((error) => {
                setprogress(false);
                seterror("Sorry there was an error try again later");
            });
    };

    //fetch all user blogs
    const fetchallblogs = (userid) => {
        axios.post(Fetchindividualblogsurl, { id: userid }).then((response) => {
            if (!response.data.message) {
                setblogs(response.data);
            }
        });
    };

    const closepopupdiv = () => {
        setpopupdiv(false);
    };

    const onsuccesslogin = () => {
        onrefresh();
        setshowloginpopup(false);
        setrefresh(!refresh);
    };

    //show login to go to moy properties
    const onsuccesslogin2 = () => {
        onrefresh();
        navigate("/nav/myproperties", {
            state: {
                message: "addproperty",
            },
        });
    };

    //follow author
    const followauthor = () => {
        if (user) {
            setprogress(true);
            seterror(null);
            axios
                .post(Followblogurl, {
                    blogerid: blog.userid,
                    userid: user?.id,
                })
                .then((response) => {
                    setprogress(false);
                    if (!response.data.message) {
                        getblog();
                    } else {
                        seterror(response.data.message);
                    }
                    //
                })
                .catch((error) => {
                    setprogress(false);
                    seterror("Sorry there was an error try again later");
                });
        } else {
            setshowloginpopup(true);
        }
    };

    //subscribe author
    const subscribeauthor = () => {
        if (user) {
            setprogress(true);
            seterror(null);
            axios
                .post(Subscribeblogurl, {
                    blogerid: blog.userid,
                    userid: user?.id,
                })
                .then((response) => {
                    setprogress(false);
                    if (!response.data.message) {
                        getblog();
                    } else {
                        seterror(response.data.message);
                    }
                    //
                })
                .catch((error) => {
                    setprogress(false);
                    seterror("Sorry there was an error try again later");
                });
        } else {
            setshowloginpopup(true);
        }
    };

    // ---------- Derived / memoized values (presentation only) ----------
    const readingTime = useMemo(() => blogminutes(blog?.content), [blog?.content]);

    const followersCount = useMemo(() => {
        try {
            return blog?.blogfollowers ? JSON.parse(blog.blogfollowers)?.length : 0;
        } catch {
            return 0;
        }
    }, [blog?.blogfollowers]);

    const copyLink = useCallback(() => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(() => setlinkcopied(true));
        }
    }, [url]);

    const goToRelatedBlog = useCallback(
        (blogId) => {
            navigate(`/nav/viewsingleblog/${blogId}`);
        },
        [navigate]
    );

    const isLoading = progress && !blog?.title;

    return (
        <Box component="main" sx={{ bgcolor: brand.bg, minHeight: "100vh" }}>
            {/* Reading progress bar */}
            <LinearProgress
                variant="determinate"
                value={scrollprogress}
                aria-label="Article reading progress"
                sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1301,
                    height: 3,
                    bgcolor: "transparent",
                    "& .MuiLinearProgress-bar": { bgcolor: brand.indigo },
                }}
            />

            <Snackbar open={Boolean(error)} autoHideDuration={3000} onClose={() => seterror("")}>
                <Alert severity="error" onClose={() => seterror("")}>
                    {error}
                </Alert>
            </Snackbar>

            <Snackbar
                open={linkcopied}
                autoHideDuration={2200}
                onClose={() => setlinkcopied(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert severity="success" onClose={() => setlinkcopied(false)}>
                    Link copied to clipboard
                </Alert>
            </Snackbar>

            <Dialog open={showloginpopup} onClose={() => setshowloginpopup(false)} maxWidth="xs" fullWidth>
                <SignIn onsuccesslogin={onsuccesslogin} />
            </Dialog>

            <Dialog open={showloginpopup2} onClose={() => setshowloginpopup2(false)} maxWidth="xs" fullWidth>
                <SignIn onsuccesslogin={onsuccesslogin2} />
            </Dialog>

            <Dialog open={sharepopup} onClose={() => setsharepopup(false)} maxWidth="xs" fullWidth>
                <Sharepopup name="Share property link through" link={url} />
            </Dialog>

            {/* Full-size image preview */}
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 2 }}
                open={popupdiv}
                onClick={closepopupdiv}
            >
                <Box
                    component="img"
                    src={defaulturl}
                    alt={blog?.title ? `${blog.title} — full size` : "Article image"}
                    sx={{
                        width: isMobile ? "100%" : isDesktop ? 800 : 500,
                        height: isMobile ? 400 : isDesktop ? 600 : 500,
                        objectFit: "contain",
                        mx: "auto",
                        borderRadius: 2,
                    }}
                />
            </Backdrop>

            <Universalheader />

            <Container maxWidth="lg" sx={{ pt: 3 }}>
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 1 }}>
                    <Tooltip title="Go back">
                        <IconButton onClick={() => navigate(-1)} aria-label="Go back" size="small">
                            <ArrowBackIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/nav" style={{ textDecoration: "none", color: brand.slate }}>
                            Home
                        </Link>
                        <Typography
                            component="span"
                            onClick={() => navigate("/nav/eaziblog")}
                            sx={{ cursor: "pointer", color: brand.slate }}
                        >
                            Blogs
                        </Typography>
                        <Typography component="span" color="text.primary" noWrap sx={{ maxWidth: 240 }}>
                            {isLoading ? <Skeleton width={120} /> : blog?.title}
                        </Typography>
                    </Breadcrumbs>
                </Stack>
            </Container>

            {/* ---------- Hero section ---------- */}
            <Box
                component="section"
                sx={{
                    background: `linear-gradient(180deg, rgba(79,70,229,0.06) 0%, ${brand.bg} 100%)`,
                    pt: { xs: 3, md: 5 },
                    pb: { xs: 4, md: 6 },
                }}
            >
                <Container maxWidth="lg">
                    {isLoading ? (
                        <Stack spacing={2}>
                            <Skeleton variant="text" height={64} width="90%" />
                            <Skeleton variant="text" height={32} width="50%" />
                            <Skeleton variant="rectangular" height={420} sx={{ borderRadius: 5 }} />
                        </Stack>
                    ) : (
                        <>
                            <motion.div initial="hidden" animate="show" variants={fadeUp}>
                                <Typography
                                    variant="h2"
                                    component="h1"
                                    fontWeight={800}
                                    letterSpacing="-0.02em"
                                    sx={{ fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" }, lineHeight: 1.15, mb: 3 }}
                                >
                                    {blog?.title}
                                </Typography>
                            </motion.div>

                            <motion.div initial="hidden" animate="show" custom={1} variants={fadeUp}>
                                <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    justifyContent="space-between"
                                    alignItems={{ xs: "flex-start", sm: "center" }}
                                    spacing={2}
                                    sx={{ mb: 3 }}
                                >
                                    <Stack direction="row" spacing={1.5} alignItems="center">
                                        <Avatar
                                            src={blog?.profile_url ? blog.profile_url : imageplaceholder}
                                            alt={blog?.username}
                                            sx={{ width: 48, height: 48 }}
                                        />
                                        <Box>
                                            <Typography fontWeight={700} variant="body2">
                                                {blog?.username}
                                            </Typography>
                                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                                <Typography variant="caption" color={brand.slate}>
                                                    {blog?.dateposted}
                                                </Typography>
                                                <Chip
                                                    icon={<ScheduleIcon sx={{ fontSize: 14 }} />}
                                                    label={`${readingTime} min read`}
                                                    size="small"
                                                    sx={{ bgcolor: "rgba(79,70,229,0.08)", color: brand.indigo, fontWeight: 600 }}
                                                />
                                                {typeof blog?.views !== "undefined" && (
                                                    <Chip
                                                        icon={<VisibilityIcon sx={{ fontSize: 14 }} />}
                                                        label={`${blog.views} views`}
                                                        size="small"
                                                        variant="outlined"
                                                    />
                                                )}
                                            </Stack>
                                        </Box>
                                    </Stack>

                                    <Stack direction="row" spacing={1}>
                                        <Tooltip title={bookmarked ? "Remove bookmark" : "Bookmark article"}>
                                            <IconButton
                                                onClick={() => setbookmarked((b) => !b)}
                                                aria-label={bookmarked ? "Remove bookmark" : "Bookmark article"}
                                                sx={{ border: "1px solid", borderColor: "divider" }}
                                            >
                                                {bookmarked ? <BookmarkIcon sx={{ color: brand.indigo }} /> : <BookmarkBorderIcon />}
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Share article">
                                            <IconButton
                                                onClick={() => setsharepopup(true)}
                                                aria-label="Share article"
                                                sx={{ border: "1px solid", borderColor: "divider" }}
                                            >
                                                <ShareIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                </Stack>
                            </motion.div>

                            {blog?.tags?.length > 0 && (
                                <motion.div initial="hidden" animate="show" custom={1.5} variants={fadeUp}>
                                    <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 3, rowGap: 1 }}>
                                        {blog.tags.map((tag) => (
                                            <Chip key={tag} icon={<LocalOfferIcon sx={{ fontSize: 14 }} />} label={tag} size="small" />
                                        ))}
                                    </Stack>
                                </motion.div>
                            )}

                            <motion.div
                                initial={{ opacity: 0, scale: 0.97 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.6, ease: "easeOut" }}
                            >
                                <Box
                                    sx={{
                                        borderRadius: 5,
                                        overflow: "hidden",
                                        boxShadow: "0 24px 48px rgba(17,24,39,0.12)",
                                        cursor: "zoom-in",
                                    }}
                                    onClick={() => setpopupdiv(true)}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="View full-size image"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") setpopupdiv(true);
                                    }}
                                >
                                    <motion.img
                                        src={blog?.blogurl}
                                        alt={blog?.title}
                                        loading="lazy"
                                        whileHover={{ scale: 1.03 }}
                                        transition={{ duration: 0.4 }}
                                        style={{
                                            width: "100%",
                                            display: "block",
                                            objectFit: "cover",
                                            maxHeight: 480,
                                        }}
                                    />
                                </Box>
                            </motion.div>
                        </>
                    )}
                </Container>
            </Box>

            {/* ---------- Article + sidebar ---------- */}
            <Container maxWidth="lg" sx={{ pb: 8 }}>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" },
                        gap: 4,
                        alignItems: "start",
                    }}
                >
                    <Box>
                        <motion.div initial="hidden" animate="show" custom={2} variants={fadeUp}>
                            <Paper
                                component="article"
                                elevation={0}
                                sx={{
                                    maxWidth: 850,
                                    mx: "auto",
                                    p: { xs: 3, sm: 5 },
                                    borderRadius: 5,
                                    border: "1px solid",
                                    borderColor: "divider",
                                    boxShadow: "0 10px 30px rgba(17,24,39,0.05)",
                                }}
                            >
                                {isLoading ? (
                                    <Stack spacing={1.5}>
                                        {Array.from({ length: 8 }).map((_, i) => (
                                            <Skeleton key={i} variant="text" height={24} width={i % 3 === 0 ? "95%" : "100%"} />
                                        ))}
                                    </Stack>
                                ) : (
                                    <Box
                                        dangerouslySetInnerHTML={createMarkup(blog.content)}
                                        sx={{
                                            "& h1, & h2, & h3": { fontWeight: 700, mt: 4, mb: 2, lineHeight: 1.3 },
                                            "& p": { mb: 2.5, lineHeight: 1.9, fontSize: "1.05rem", color: "text.primary" },
                                            "& a": { color: brand.blueAccent, textDecoration: "underline" },
                                            "& blockquote": {
                                                borderLeft: `4px solid ${brand.indigo}`,
                                                pl: 3,
                                                py: 1,
                                                my: 3,
                                                fontStyle: "italic",
                                                bgcolor: "rgba(79,70,229,0.04)",
                                                borderRadius: 1,
                                            },
                                            "& img": { maxWidth: "100%", borderRadius: 3, my: 3, display: "block" },
                                            "& pre": {
                                                bgcolor: "grey.900",
                                                color: "common.white",
                                                p: 2,
                                                borderRadius: 2,
                                                overflowX: "auto",
                                                my: 3,
                                            },
                                            "& code": {
                                                bgcolor: "grey.100",
                                                px: 0.75,
                                                py: 0.25,
                                                borderRadius: 1,
                                                fontFamily: "monospace",
                                                fontSize: "0.9em",
                                            },
                                            "& pre code": { bgcolor: "transparent", p: 0 },
                                            "& table": { width: "100%", borderCollapse: "collapse", my: 3 },
                                            "& th, & td": { border: "1px solid", borderColor: "divider", p: 1.5, textAlign: "left" },
                                            "& ul, & ol": { pl: 3, mb: 2.5, lineHeight: 1.9 },
                                        }}
                                    />
                                )}
                            </Paper>
                        </motion.div>
                    </Box>

                    {/* ---------- Sticky author sidebar ---------- */}
                    <Box sx={{ position: { md: "sticky" }, top: { md: 96 } }}>
                        <motion.div initial="hidden" animate="show" custom={2.5} variants={fadeUp}>
                            <Card
                                component="aside"
                                aria-label="About the author"
                                elevation={0}
                                sx={{
                                    p: 3.5,
                                    borderRadius: 5,
                                    border: "1px solid",
                                    borderColor: "divider",
                                    boxShadow: "0 12px 32px rgba(17,24,39,0.06)",
                                    textAlign: "center",
                                }}
                            >
                                {isLoading ? (
                                    <Stack spacing={2} alignItems="center">
                                        <Skeleton variant="circular" width={80} height={80} />
                                        <Skeleton width="60%" />
                                        <Skeleton width="90%" />
                                    </Stack>
                                ) : (
                                    <>
                                        <Avatar
                                            src={blog?.profile_url ? blog.profile_url : imageplaceholder}
                                            alt={blog?.username}
                                            sx={{ width: 80, height: 80, mx: "auto", mb: 2 }}
                                        />
                                        <Typography variant="h6" fontWeight={700}>
                                            {blog?.username}
                                        </Typography>
                                        <Chip
                                            icon={<PeopleAltIcon sx={{ fontSize: 14 }} />}
                                            label={`${followersCount} follower${followersCount === 1 ? "" : "s"}`}
                                            size="small"
                                            sx={{ my: 1.5 }}
                                        />
                                        <Typography variant="body2" color={brand.slate} sx={{ mb: 3 }}>
                                            {blog?.bio}
                                        </Typography>

                                        <Stack direction="row" spacing={1.5} justifyContent="center" alignItems="center">
                                            <Button
                                                onClick={followauthor}
                                                variant="contained"
                                                sx={{
                                                    borderRadius: 20,
                                                    px: 3,
                                                    bgcolor: brand.indigo,
                                                    "&:hover": { bgcolor: brand.indigoDark },
                                                }}
                                            >
                                                {followingstatus ? "Unfollow" : "Follow"}
                                            </Button>
                                            <Tooltip title={`Subscribe to get an email whenever ${blog?.username} publishes`}>
                                                <IconButton
                                                    onClick={subscribeauthor}
                                                    aria-label={
                                                        subscribingstatus ? "Unsubscribe from author emails" : "Subscribe to author emails"
                                                    }
                                                    sx={{
                                                        border: "1px solid",
                                                        borderColor: subscribingstatus ? brand.indigo : "divider",
                                                        color: subscribingstatus ? brand.indigo : "inherit",
                                                    }}
                                                >
                                                    {subscribingstatus ? <MarkEmailRead /> : <Email />}
                                                </IconButton>
                                            </Tooltip>
                                        </Stack>

                                        <Divider sx={{ my: 3 }} />

                                        <Button
                                            onClick={copyLink}
                                            startIcon={<ContentCopyIcon />}
                                            size="small"
                                            color="inherit"
                                            fullWidth
                                            sx={{ justifyContent: "flex-start", color: brand.slate }}
                                        >
                                            Copy article link
                                        </Button>
                                    </>
                                )}
                            </Card>
                        </motion.div>
                    </Box>
                </Box>

                {/* ---------- Related articles ---------- */}
                {blogs?.length > 0 && (
                    <Box component="section" sx={{ mt: 8 }} aria-label={`More from ${blog?.username}`}>
                        <Typography variant="h5" fontWeight={800} sx={{ mb: 3 }}>
                            More from {blog?.username}
                        </Typography>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
                                gap: 3,
                            }}
                        >
                            {blogs.map((val, key) => (
                                <Box key={val.id ?? key}>
                                    <motion.div
                                        initial="hidden"
                                        whileInView="show"
                                        viewport={{ once: true, margin: "-60px" }}
                                        custom={key}
                                        variants={fadeUp}
                                        style={{ height: "100%" }}
                                    >
                                        <Card
                                            elevation={0}
                                            sx={{
                                                height: "100%",
                                                borderRadius: 4,
                                                border: "1px solid",
                                                borderColor: "divider",
                                                boxShadow: "0 8px 24px rgba(17,24,39,0.05)",
                                                transition: "transform 0.25s ease, box-shadow 0.25s ease",
                                                "&:hover": {
                                                    transform: "translateY(-4px)",
                                                    boxShadow: "0 16px 32px rgba(17,24,39,0.1)",
                                                },
                                            }}
                                        >
                                            <CardActionArea
                                                onClick={() => goToRelatedBlog(val.id)}
                                                sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "stretch" }}
                                                aria-label={`Read ${val.title}`}
                                            >
                                                <Box
                                                    component="img"
                                                    src={val.blogurl}
                                                    alt={val.title}
                                                    loading="lazy"
                                                    sx={{ width: "100%", height: 160, objectFit: "cover" }}
                                                />
                                                <Box sx={{ p: 2 }}>
                                                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 0.5 }} noWrap>
                                                        {val.title}
                                                    </Typography>
                                                    <Typography variant="caption" color={brand.slate}>
                                                        {blogminutes(val.content)} min read
                                                    </Typography>
                                                </Box>
                                            </CardActionArea>
                                        </Card>
                                    </motion.div>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                )}
            </Container>

            {/* ---------- Floating share speed dial ---------- */}
            <SpeedDial
                ariaLabel="Share this article"
                icon={<SpeedDialIcon icon={<ShareIcon />} />}
                sx={{
                    position: "fixed",
                    bottom: { xs: 24, md: 32 },
                    right: { xs: 24, md: 32 },
                    "& .MuiFab-primary": { bgcolor: brand.indigo, "&:hover": { bgcolor: brand.indigoDark } },
                }}
            >
                <SpeedDialAction
                    icon={<ContentCopyIcon />}
                    slotProps={{ tooltip: { title: "Copy link" } }}
                    onClick={copyLink}
                />
                <SpeedDialAction
                    icon={<WhatsAppIcon />}
                    slotProps={{ tooltip: { title: "Share on WhatsApp" } }}
                    onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(url)}`, "_blank")}
                />
                <SpeedDialAction
                    icon={<FacebookIcon />}
                    slotProps={{ tooltip: { title: "Share on Facebook" } }}
                    onClick={() =>
                        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, "_blank")
                    }
                />
                <SpeedDialAction
                    icon={<ShareIcon />}
                    slotProps={{ tooltip: { title: "More options" } }}
                    onClick={() => setsharepopup(true)}
                />
            </SpeedDial>
        </Box>
    );
};

export default Viewsingleblog;